import { render, staticRenderFns } from "./ArticleItem.vue?vue&type=template&id=79efdb2c&scoped=true"
import script from "./ArticleItem.vue?vue&type=script&lang=js"
export * from "./ArticleItem.vue?vue&type=script&lang=js"
import style0 from "./ArticleItem.vue?vue&type=style&index=0&id=79efdb2c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f87e3863bbacd24b3d835a89ae544fd6/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79efdb2c",
  null
  
)

export default component.exports